import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  FetchProductionDevicesPayload,
  GetProductionDevicePayload,
  ProductionDevice,
  ProductionDeviceSearchResponse,
  SearchProductionDevicePayload,
  UpdateProductionDevicePayload,
} from '../types/eecs-production-device.types';

export const productionDeviceApi = createApi({
  reducerPath: 'productionDeviceApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/necs`),
  endpoints: (builder) => ({
    fetchProductionDevices: builder.query<ApiPaginationResponse<ProductionDevice[]>, FetchProductionDevicesPayload>({
      query: (params) => ({
        url: `/production-devices`,
        method: 'GET',
        params,
      }),
    }),
    getProductionDevice: builder.query<ApiResponse<ProductionDevice>, GetProductionDevicePayload>({
      query: (params) => ({
        url: `/production-devices/${params.id}`,
        method: 'GET',
      }),
    }),

    updateProductionDevice: builder.mutation<ApiResponse<ProductionDevice>, UpdateProductionDevicePayload>({
      query: (payload) => ({
        url: `/production-devices/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),

    searchProductionDevices: builder.query<
      ApiResponse<ProductionDeviceSearchResponse[]>,
      SearchProductionDevicePayload
    >({
      query: (params) => ({
        url: `/production-devices/search`,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useLazyGetProductionDeviceQuery,
  useUpdateProductionDeviceMutation,
  useLazyFetchProductionDevicesQuery,
  useLazySearchProductionDevicesQuery,
} = productionDeviceApi;
